var FullScreenModalCloseReason;
(function (FullScreenModalCloseReason) {
  FullScreenModalCloseReason["outsideClick"] = "outsideClick";
  FullScreenModalCloseReason["cancelClick"] = "cancelClick";
  FullScreenModalCloseReason["escapePress"] = "escapePress";
})(FullScreenModalCloseReason || (FullScreenModalCloseReason = {}));

export { FullScreenModalCloseReason as F };
